import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";

interface HazardControlAmendDialogProps {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    hazardControl: any;
    updateControl: (payload: any) => void;
}

const HazardControlAmendDialog = ({
    isOpen,
    setIsOpen,
    hazardControl,
    updateControl,
}: HazardControlAmendDialogProps) => {
    const [hazardControlText, setHazardControlText] = useState("");

    useEffect(() => {
        if (hazardControl) {
            setHazardControlText(hazardControl?.control?.name ?? "");
        }

    }, [hazardControl]);

    const handleUpdateHazardControlText = (value: string) => {
        setHazardControlText(value);
    };

    const handleConfirm = async e => {
        e.preventDefault();
        updateControl({ controlId: hazardControl?.control?.id, hazardControlText, isCustomHazard: hazardControl?.control?.isCustomHazard, isCustomControl: hazardControl?.isCustomControl })
        handleClose();
        }

    const handleClose = () => {
        setIsOpen(false);
    };

  return (
      <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>{hazardControl?.id ? "Edit " : "Add "} Hazard Control Text</DialogTitle>
          <DialogContent>

              <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Hazard Control Details"
                  multiline
                  variant="outlined"
                  value={hazardControlText}
                  onChange={(e) => handleUpdateHazardControlText(e.target.value)}
              />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HazardControlAmendDialog;
